import { type FunctionComponent } from "react";

import planswiftIcon from "images/Common/planswift.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedPlanswift: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={planswiftIcon} style={baseProps.style} className={baseProps.className} />
    );
};
